import { render } from "./MonitorFaultySites.vue?vue&type=template&id=03b99536&scoped=true"
import script from "./MonitorFaultySites.vue?vue&type=script&lang=js"
export * from "./MonitorFaultySites.vue?vue&type=script&lang=js"

import "./MonitorFaultySites.vue?vue&type=style&index=0&id=03b99536&scoped=true&lang=css"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b99536"]])

export default __exports__